import { createReducer } from '@reduxjs/toolkit';
import { BillingActions } from './actions';
import Constants from './constants';

const initialState = {
  isLoadingBilling: false,
  isLoadingInvoices: false,
  editingCardLoading: false,
  onBoardingCardLoading: false,
  billingInformation: {},
  invoices: [],
  billingEditMode: false,
  usersData: {},
  currentPage: 1,
};

const ACTION_HANDLER = {
  [BillingActions.billingInfoFetch]: (state) => {
    state.isLoadingBilling = true;
  },
  [BillingActions.invoicesFetchRequest]: (state) => {
    state.isLoadingInvoices = true;
  },
  [BillingActions.connectingToStripeFailed]: (state) => {
    state.editingCardLoading = false;
  },
  [BillingActions.connectingToStripe]: (state) => {
    state.editingCardLoading = true;
  },
  [BillingActions.addCreditCard]: (state) => {
    state.editingCardLoading = true;
  },
  [BillingActions.addCreditCardFailed]: (state) => {
    state.editingCardLoading = false;
  },
  [BillingActions.billingInfoFetchSucceeded]: (state, action) => {
    state.billingInformation = action.payload;
    state.isLoadingBilling = false;
  },
  [BillingActions.billingInfoFetchFailed]: (state, action) => {
    state.isLoadingBilling = false;
  },
  [BillingActions.invoicesFetchSucceeded]: (state, action) => {
    state.invoices = action.payload.results;
    state.usersData = action.payload;
    state.isLoadingInvoices = false;
  },
  [BillingActions.invoicesFetchFailed]: (state, action) => {
    state.isLoadingInvoices = false;
  },
  [BillingActions.addCreditCardSucceeded]: (state) => {
    state.billingEditMode = false;
    state.editingCardLoading = false;
  },
  [BillingActions.toggleBillingEditMode]: (state) => {
    state.billingEditMode = !state.billingEditMode;
  },
  [BillingActions.billingNextPage]: (state) => {
    state.currentPage += 1;
  },
  [BillingActions.billingPreviousPage]: (state) => {
    state.currentPage -= 1;
  },
  [BillingActions.setBillingPage]: (state, action) => {
    state.currentPage = action.payload;
  },
  [BillingActions.setBillingEditMode]: (state) => {
    state.billingEditMode = true;
  },
  [BillingActions.addCreditCardOnBoarding]: (state) => {
    state.editingCardLoading = true;
  },
  [BillingActions.addCreditCardOnBoardingFailed]: (state) => {
    state.editingCardLoading = false;
  },
  [BillingActions.addCreditCardOnBoardingSucceeded]: (state) => {
    state.editingCardLoading = false;
  },
};

export const billingReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: billingReducer,
};
